import React from "react";
import { ChartBar, TrendingUp, Star } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import ReturnsChart from "@/components/onepager/ReturnsChart";
const ReturnsSection: React.FC = () => {
  return <div className="p-12 h-full flex flex-col">
      <h2 className="text-3xl font-bold text-noa-rich-black mb-4">
        Returns & Value Creation
      </h2>
      <Separator className="mb-8 bg-gray-200" />
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <ChartBar className="w-5 h-5 text-blue-500" />
            <h3 className="text-xl font-semibold text-noa-rich-black">Projected 10‑Year Returns
          </h3>
          </div>
          
          <div className="bg-white border border-gray-100 rounded-lg p-5 shadow-sm">
            <p className="text-gray-700 mb-4">
              The financial model assumes 7× entry multiples. We're closing deals at ≤ 5× EBITDA today—adding two full turns of un‑modeled upside.
            </p>
            
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div className="bg-blue-50 p-3 rounded-lg">
                <h4 className="font-semibold text-blue-800 mb-1">MOIC</h4>
                <p className="text-3xl font-bold text-blue-900">22x</p>
                
              </div>
              
              <div className="bg-emerald-50 p-3 rounded-lg">
                <h4 className="font-semibold text-emerald-800 mb-1">IRR</h4>
                <p className="text-3xl font-bold text-emerald-900">85%</p>
                
              </div>
            </div>
          </div>
        </div>
        
        <div>
          <div className="flex items-center gap-2 mb-4">
            <TrendingUp className="w-5 h-5 text-blue-500" />
            <h3 className="text-xl font-semibold text-noa-rich-black">Key assumptions </h3>
          </div>
          
          <div className="bg-white border border-gray-100 rounded-lg p-5 shadow-sm">
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <div className="bg-blue-100 p-2 rounded-full text-blue-700 font-bold text-sm flex items-center justify-center w-6 h-6 flex-shrink-0">
                  1
                </div>
                <div>
                  <p className="font-semibold text-gray-800">Equity Raise</p>
                  <p className="text-sm text-gray-600">US $20 million</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="bg-blue-100 p-2 rounded-full text-blue-700 font-bold text-sm flex items-center justify-center w-6 h-6 flex-shrink-0">
                  2
                </div>
                <div>
                  <p className="font-semibold text-gray-800">Leverage Discipline</p>
                  <p className="text-sm text-gray-600">≤ 2× Debt / EBITDA </p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="bg-blue-100 p-2 rounded-full text-blue-700 font-bold text-sm flex items-center justify-center w-6 h-6 flex-shrink-0">
                  3
                </div>
                <div>
                  <p className="font-semibold text-gray-800">Organic Growth</p>
                  <p className="text-sm text-gray-600">≈ 20% annually (before any M&A)</p>
                </div>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="bg-blue-100 p-2 rounded-full text-blue-700 font-bold text-sm flex items-center justify-center w-6 h-6 flex-shrink-0">
                  4
                </div>
                <div>
                  <p className="font-semibold text-gray-800">Programmatic M&A</p>
                  <p className="text-sm text-gray-600">35 VMS assets added over 10 years</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="bg-blue-100 p-2 rounded-full text-blue-700 font-bold text-sm flex items-center justify-center w-6 h-6 flex-shrink-0">
                  5
                </div>
                <div>
                  <p className="font-semibold text-gray-800">Inorganic Growth</p>
                  <p className="text-sm text-gray-600">Acquire new ARR each year equal to 20 % of the prior year’s base.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="flex-grow">
        <div className="flex items-center gap-2 mb-4">
          <Star className="w-5 h-5 text-amber-500" />
          <h3 className="text-xl font-semibold text-noa-rich-black">Platform 10‑Year Scale
        </h3>
        </div>
        <ReturnsChart />
      </div>
    </div>;
};
export default ReturnsSection;